import PropTypes from 'prop-types';

export const InputAdornmentPosition = {
  Start: 'start',
  End: 'end',
};

export const InputAdornmentPositionPropType = PropTypes.oneOf([InputAdornmentPosition.Start, InputAdornmentPosition.End]);
